/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Eigen_UitlegInputs */

const nl_planning_vakanties_eigen_uitleg = /** @type {(inputs: Planning_Vakanties_Eigen_UitlegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`studiedagen en andere dagen zonder gym`)
};

/**

* @param {Planning_Vakanties_Eigen_UitlegInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_eigen_uitleg = /** @type {((inputs?: Planning_Vakanties_Eigen_UitlegInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Eigen_UitlegInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_eigen_uitleg(inputs)
});
export { planning_vakanties_eigen_uitleg as "planning.vakanties.eigen_uitleg" }